<ng-container *ngFor="let field of data; let index = index">
  <div
    *ngIf="field?.value || config?.placeholder"
    class="label-value-pair-container"
    [ngStyle]="config?.customStyles?.container"
    [class.label-value-pair-container-vertical]="
      config?.orientation == 'vertical'
    "
  >
    <div class="label-value-pair-container-label-separator">
      <kwikui-label-value-pair-label
        [config]="config"
        [label]="field?.label"
      ></kwikui-label-value-pair-label>

      <kwikui-label-value-pair-separator
        [separator]="config?.separator"
      ></kwikui-label-value-pair-separator>
    </div>

    <div>
      <kwikui-label-value-pair-value
        *ngIf="field?.value != undefined"
        [config]="config"
        [value]="field?.value"
      ></kwikui-label-value-pair-value>

      <kwikui-label-value-pair-placeholder
        *ngIf="field?.value == undefined"
        [placeholder]="config?.placeholder"
      ></kwikui-label-value-pair-placeholder>
    </div>
  </div>
</ng-container>
